import { dispatchAction } from '@ardoq/rxbeach';
import {
  addRequiredComponent,
  graphNodeHovered,
  removeRequiredComponent,
} from './requiredComponentsActions';

export const getRequiredComponentsCommands = (namespace: string) => ({
  toggleIsSelectedGraphNode: (nodeId: string) => {
    dispatchAction(addRequiredComponent(nodeId), namespace);
  },
  removeRequiredComponent: (nodeId: string) => {
    dispatchAction(removeRequiredComponent(nodeId), namespace);
  },
  onGraphNodeHover: (nodeId: string | null) => {
    dispatchAction(graphNodeHovered(nodeId), namespace);
  },
  highlightPath: (nodeId: string | null) => {
    dispatchAction(graphNodeHovered(nodeId), namespace);
  },
});

export type RequiredComponentsCommands = ReturnType<
  typeof getRequiredComponentsCommands
>;
